import React, { useMemo } from "react";
import { motion } from "framer-motion";

const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

/* A single-shot gold particle burst + dust puff at a fixed screen point */
export default function ParticleBurst({ x, y }) {
  const sparks = useMemo(() => {
    const n = isMobile ? 10 : 22;
    return Array.from({ length: n }).map((_, i) => {
      const angle = (Math.PI * 2 * i) / n + Math.random() * 0.5;
      const dist = 40 + Math.random() * 90;
      return {
        id: i,
        dx: Math.cos(angle) * dist,
        dy: Math.sin(angle) * dist * 0.7 + 30,
        size: 3 + Math.random() * 5,
        dur: 0.7 + Math.random() * 0.6,
      };
    });
  }, []);

  return (
    <div className="burst-layer" style={{ left: x, top: y }} data-testid="particle-burst">
      {/* dust puff */}
      <motion.div
        initial={{ scale: 0, opacity: 0.5 }}
        animate={{ scale: 3.4, opacity: 0 }}
        transition={{ duration: 1.1, ease: "easeOut" }}
        style={{
          position: "absolute",
          width: 60,
          height: 60,
          marginLeft: -30,
          marginTop: -30,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(212,175,55,0.28), rgba(150,150,150,0.12) 45%, rgba(0,0,0,0) 70%)",
          filter: "blur(6px)",
        }}
      />
      {sparks.map((s) => (
        <motion.span
          key={s.id}
          className="spark"
          initial={{ x: 0, y: 0, opacity: 1, scale: 1 }}
          animate={{ x: s.dx, y: s.dy, opacity: 0, scale: 0.2 }}
          transition={{ duration: s.dur, ease: "easeOut" }}
          style={{ width: s.size, height: s.size, marginLeft: -s.size / 2, marginTop: -s.size / 2 }}
        />
      ))}
    </div>
  );
}
